var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"px-5 py-5",attrs:{"tile":"","elevation":"0"}},[_c('v-img',{style:(_vm.styleSettings),attrs:{"src":_vm.logo,"alt":"Store Logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }